{
  "login": {
    "title": "Bine ai revenit",
    "subtitle": "Autentifică-te pentru a continua.",
    "email": "E-mail",
    "password": "Parolă",
    "remember": "Ține-mă minte",
    "submit": "Autentificare",
    "forgot": "Ai uitat parola?",
    "invalid": "Date de autentificare incorecte",
    "required": "E-mailul și parola sunt obligatorii"
  },
  "forgot": {
    "title": "Resetează-ți parola",
    "subtitle": "Introdu adresa de e-mail și îți trimitem un link de resetare.",
    "email": "E-mail",
    "submit": "Trimite linkul de resetare",
    "back": "Înapoi la autentificare",
    "sent": "Dacă adresa există, am trimis un link de resetare."
  },
  "reset": {
    "title": "Alege o parolă nouă",
    "subtitle": "Introdu o parolă nouă pentru contul tău.",
    "password": "Parolă nouă",
    "confirm": "Confirmă parola",
    "submit": "Setează parola nouă",
    "back": "Înapoi la autentificare",
    "success": "Parola a fost schimbată. Acum te poți autentifica.",
    "signin": "Mergi la autentificare",
    "mismatch": "Cele două parole nu coincid.",
    "tooShort": "Parola trebuie să aibă cel puțin 8 caractere.",
    "missingToken": "Acest link de resetare este invalid sau incomplet. Solicită unul nou.",
    "invalidToken": "Acest link de resetare este invalid sau a expirat. Solicită unul nou."
  },
  "dashboard": {
    "welcome": "Bun venit, {name}",
    "subtitle": "Iată școala ta pe scurt.",
    "placeholder": "Widgeturile panoului vor apărea aici pe măsură ce adaugi cursanți, clase și evenimente."
  },
  "portalLogin": {
    "title": "Portal cursanți",
    "subtitle": "Autentifică-te ca să-ți vezi cursurile și progresul.",
    "submit": "Autentificare"
  }
}
